import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild} from "@angular/router";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AuthService} from "./auth.service";

@Injectable()
export class ProfileResolver implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    let url;
    if(route.fragment) {
      this.authService.setTokenFromUrl(route.fragment);
    }
    if(sessionStorage.getItem('deepLink')){
      url = sessionStorage.getItem('deepLink');
      sessionStorage.removeItem('deepLink')
    }
    if(this.authService.isLoggedIn()){
      if(this.authService.getUserProfile().firstLogin)
        return Observable.of(true);
      else{
       if(url){
         this.router.navigate([url]);
         return;
       }
        this.router.navigate(['/things'])
      }


      return Observable.of(true);
    }

    return this.authService.isUserProfileExist()
      .map(e => {
        if (e) {
          if(this.authService.getUserProfile().firstLogin)
             this.router.navigate(['/intro']);
          else{
            if(url){
              this.router.navigate([url]);
              return;
            }

            this.router.navigate(['/things'])
          }


          return Observable.of(true);
        }
        else{
          this.router.navigate(['/']);
          return Observable.of(false);
        }
      }).catch(() => {
        this.router.navigate(['/']);
        return Observable.of(false);
      });

  }
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/profile-resolver.ts